(function (app) {
    app.run([
        "$transitions", "$location", "$window", function ($transitions, $location, $window) {
            $window.ga("create", "UA-19217975-4", "auto");
            $transitions.onSuccess({},
               function() {
                    $window.ga("set", "page", $location.path());
                    $window.ga("send", "pageview");
                });
        }
    ]);
})(window.app); //jshint ignore:line